import React from "react";
import { Box, Card, Divider, Stack, Typography } from "@mui/material";

export interface SectionCardProps {
  title: string;
  subtitle?: string;
  action?: React.ReactNode;
  children: React.ReactNode;
  contentSx?: Record<string, any>;
}

export default function SectionCard({
  title,
  subtitle,
  action,
  children,
  contentSx,
}: SectionCardProps) {
  return (
    <Card
      sx={{
        borderRadius: "12px",
        border: "1px solid #E2E8EE",
        boxShadow: "0 10px 25px rgba(16,33,49,0.05)",
      }}
    >
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="flex-start"
        spacing={2}
        sx={{ px: 2.5, pt: 2.25, pb: 1.5 }}
      >
        <Box>
          <Typography sx={{ fontSize: 18, fontWeight: 800, color: "#17324D", lineHeight: 1.2 }}>
            {title}
          </Typography>
          {subtitle ? (
            <Typography sx={{ fontSize: 13, color: "#66788A", mt: 0.5, lineHeight: 1.6 }}>
              {subtitle}
            </Typography>
          ) : null}
        </Box>

        {action ? <Box>{action}</Box> : null}
      </Stack>

      <Divider />

      <Box sx={{ p: 2.5, ...contentSx }}>{children}</Box>
    </Card>
  );
}
